import { Component, Inject, OnInit, PLATFORM_ID, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from "../../components/footer/footer.component";
import { HeaderComponent } from '../../components/header/header.component';
import { Web3WalletService } from '../../../services/web3-wallet.service';
import { isPlatformBrowser } from '@angular/common';
import { InfosService } from '../../../services/infos.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-component',
  imports: [
    RouterOutlet,
    TranslateModule,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss'
})
export class PageComponent implements OnInit, OnDestroy {

  title = 'beastborne-app';

  constructor(
    private readonly web3WalletService: Web3WalletService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly infosService: InfosService,
    private readonly translateService: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.web3WalletService.init()
        .then(() => {
          console.log('Wallet initialized successfully');
        })
        .catch((error) => {
          console.error('Error initializing wallet:', error);
        });

      this.infosService.getPolPrice().subscribe({
        next: (data) => {
          this.infosService.onChangePolPrice.next(data);
        },
        error: (err) => {
          console.error('Failed to load creatures:', err);
        },
      });

      setInterval(() => {
        this.infosService.getPolPrice().subscribe({
          next: (data) => {
            this.infosService.onChangePolPrice.next(data);
          },
          error: (err) => {
            console.error('Failed to load creatures:', err);
          },
        });
      }, 1000 * 60);
    }

    // Initial language is now handled in APP_INITIALIZER; still ensure sync here.
    const initialLang = this.route.snapshot.params['lang'];
    if (initialLang) {
      this.ensureLang(initialLang);
    }

    this.route.params.subscribe(p => {
      const newLang = p['lang'];
      if (newLang) {
        this.ensureLang(newLang);
      }
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  private ensureLang(lang: string) {
    const supported = ['en','ja','ko','ms','vi','zh'];
    if (!supported.includes(lang)) return;
    if (this.translateService.getCurrentLang && this.translateService.getCurrentLang() === lang) return;
    this.translateService.use(lang).subscribe({
      next: () => console.log('[i18n] ensureLang switched to', lang),
      error: (e) => console.error('[i18n] ensureLang failed', lang, e)
    });
  }
}
